import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function IndividualsSex({ data }) {
    const individualSexChart = data?.individualSex ?? [];

    useEffect(() => {
        GraphicUtils.horizontalStackedBarChart(
            individualSexChart,
            "individual-sex",
            "sex",
        );

        if (individualSexChart.length > 0) {
            const labels = individualSexChart.map(item => item.sex ?? "");
            const values = individualSexChart.map(item => Number(item.qty ?? 0));

            ReportUtils.createExportableTable(
                labels,
                values,
                "Sexo dos indivíduos abordados",
            );
        }
    }, [individualSexChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Sexo dos indivíduos abordados</span>
                <div className="mt-1" id="individual-sex" />
            </div>

            <div className="chart-divisor" />
        </>
    )
}